/**
 * @file SessionAnnotationsFormHeader.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 1, 2025 4:28 PM
 */
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import { objectExists, objectHas, stringExists } from 'src/@common/utilities';

import ListItemField from 'src/components/fieldComponents/VeriomeListItemField';

function SessionAnnotationsFormHeader(props) {
    const {
        metadata,
    } = props;

    return (
        <div className="flex flex-1 flex-col relative overflow-hidden pt-2 pl-0">

            <Paper elevation={4} className="ml-5 mt-0 mb-5 mr-5 pt-5 pl-5 pr-5"
                sx={{
                    bgcolor: 'background.default',
                }}
            >

                <Stack
                    ml={1}
                    mt={1}
                    mb={1}
                    direction={{ xs: 'column', sm: 'column' }}
                    spacing={0}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    {objectExists(metadata) &&
                        objectHas(metadata, 'title') &&
                        stringExists(metadata.title) &&
                        < ListItemField
                            label={'Document Type'}
                            value={`${metadata.title}`}
                        />
                    }

                    {objectExists(metadata) &&
                        objectHas(metadata, 'publication._id') &&
                        stringExists(metadata.publication._id) &&
                        < ListItemField
                            label={'Publication'}
                            value={`${metadata.publication.pmId}: ${metadata.publication.title}`}
                        />
                    }

                    {objectExists(metadata) &&
                        objectHas(metadata, 'supplement._id') &&
                        stringExists(metadata.supplement._id) &&
                        < ListItemField
                            label={'Supplement'}
                            value={`${metadata.supplement.title}`}
                        />
                    }

                    {objectExists(metadata) &&
                        objectHas(metadata, 'table._id') &&
                        stringExists(metadata.table._id) &&
                        < ListItemField
                            label={'Table'}
                            value={`${metadata.table.title}`}
                        />
                    }

                    {objectExists(metadata) &&
                        objectHas(metadata, 'annotator._id') &&
                        stringExists(metadata.annotator._id) &&
                        < ListItemField
                            label={'Annotator'}
                            value={`${metadata.annotator.name}`}
                        />
                    }
                </Stack>

            </Paper >

        </div >
    );
}

SessionAnnotationsFormHeader.propTypes = {
    docType: PropTypes.string.isRequired,
    metadata: PropTypes.object,
};

export default SessionAnnotationsFormHeader;
